import { memo } from 'react';

import { useTranslation } from 'react-i18next';
import { useWatch } from 'react-hook-form';

import { Grid, Label } from '@wf/sw-ui-kit';

import CompanyInfoFields from './CompanyInfoFields';
import AdditionalFields from '../AdditionalFields';
import DeclarantFields from './DeclarantFields';
import { LicenseField } from '../LicenseField';

import { HeaderTabFields, NamesAndPartiesTabFields } from '../../types/fieldEnums';
import { FieldPrefix } from '../../constants/fieldPrefixes';
import { Flow, Tab } from '../../types/enums';

import { type TRimmEntityOption } from '../../../rimm/data/rimmEntityTypes';
import { type RimmEntityType } from '../../../rimm/data/rimmEntityEnums';

import styles from './NamesAndParties.module.scss';

interface INamesAndPartiesProps {
  companyFieldsAreDisabled: boolean;
  declarantFieldAreDisabled: boolean;
  companyOptions: TRimmEntityOption[RimmEntityType.company][] | null;
}

function NamesAndParties({
  companyFieldsAreDisabled,
  declarantFieldAreDisabled,
  companyOptions,
}: INamesAndPartiesProps) {
  const { t } = useTranslation();

  const flow: Flow = useWatch({ name: HeaderTabFields.flow });

  const exporterFieldTitle = flow === Flow.IM ? 'Exporter/Sender Name & Address' : 'Receiver Name & Address';
  const exporterFieldHelpText =
    flow === Flow.IM ? 'Name and address of the sender of goods' : 'Name and address of the recipient of the goods';

  return (
    <div className={styles.namesAndPartiesView}>
      <Grid columns="repeat(3, minmax(0, 1fr))">
        <DeclarantFields disabled={declarantFieldAreDisabled} />
        <CompanyInfoFields disabled={companyFieldsAreDisabled} companyOptions={companyOptions} />
        <LicenseField.TextField
          label={<Label helpText={t(exporterFieldHelpText)}>{t(exporterFieldTitle)}</Label>}
          configName={NamesAndPartiesTabFields.exporterNameAndAddress}
          name={NamesAndPartiesTabFields.exporterNameAndAddress}
          placeholder={exporterFieldTitle}
          className={styles.twoCellField}
          textarea
        />
      </Grid>
      <AdditionalFields tab={Tab.NAMES_AND_PARTIES} configNamePrefix={FieldPrefix.lpco} />
    </div>
  );
}

export default memo(NamesAndParties);
